module.exports = __webpack_public_path__ + "img/ar04_samurai02skin_shop.8eabe42a.png";